function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.16797 5.83203C8.16797 4.86553 7.38447 4.08203 6.41797 4.08203C5.45147 4.08203 4.66797 4.86553 4.66797 5.83203C4.66797 6.79853 5.45147 7.58203 6.41797 7.58203C7.38447 7.58203 8.16797 6.79853 8.16797 5.83203ZM9.66797 5.83203C9.66797 7.62696 8.21289 9.08203 6.41797 9.08203C4.62304 9.08203 3.16797 7.62696 3.16797 5.83203C3.16797 4.03711 4.62304 2.58203 6.41797 2.58203C8.21289 2.58203 9.66797 4.03711 9.66797 5.83203Z",
  fill: "#B01BAE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 16.668C10 14.0248 8.31698 12.418 6.25 12.418C4.18302 12.418 2.5 14.0248 2.5 16.668C2.5 17.0822 2.16421 17.418 1.75 17.418C1.33579 17.418 1 17.0822 1 16.668C1 13.3112 3.24425 10.918 6.25 10.918C9.25575 10.918 11.5 13.3112 11.5 16.668C11.5 17.0822 11.1642 17.418 10.75 17.418C10.3358 17.418 10 17.0822 10 16.668Z",
  fill: "#B01BAE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.417 9.58301C17.4168 8.98485 16.9312 8.5 16.333 8.5C15.735 8.50018 15.2502 8.98496 15.25 9.58301C15.25 10.1812 15.7348 10.6668 16.333 10.667C16.9313 10.667 17.417 10.1813 17.417 9.58301ZM18.917 9.58301C18.917 11.0097 17.7597 12.167 16.333 12.167C14.9064 12.1668 13.75 11.0096 13.75 9.58301C13.7502 8.15653 14.9065 7.00018 16.333 7C17.7596 7 18.9168 8.15642 18.917 9.58301Z",
  fill: "#B01BAE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.501 16.667C18.501 15.1372 17.477 14.2502 16.335 14.25C15.1928 14.25 14.168 15.1371 14.168 16.667C14.1678 17.0811 13.8321 17.417 13.418 17.417C13.0039 17.417 12.6681 17.0811 12.668 16.667C12.668 14.3636 14.3105 12.75 16.335 12.75C18.3593 12.7502 20.001 14.3637 20.001 16.667C20.0008 17.0811 19.6651 17.417 19.251 17.417C18.837 17.4168 18.5012 17.0809 18.501 16.667Z",
  fill: "#B01BAE"
});

function SvgParentChild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentChild);
export default __webpack_public_path__ + "static/media/parent-child.f73bb549.svg";
export { ForwardRef as ReactComponent };